<template>
  <v-dialog v-model="localDialog" width="40%" @update:modelValue="updateDialog" transition=""persistent :open-delay="0" :close-delay="0">
    <base-card
      :title="isEntryMode ? 'Add Supplier Map' : 'Update Supplier Map'"
      :v-card-text-class="'pa-4'"
    >
      <v-form @submit.prevent="submit" ref="SupplierMapSetup">
        <v-row>
          <v-col cols="12">
            <v-autocomplete
              variant="outlined"
              density="compact"
              bg-color="grey-lighten-4"
              v-model="supplier_id.value.value"
              :items="getSupplierList.filter(item=> item.status == 1)"
              :item-title="item => item && item.name && item.code ? `${item.name} - ${item.code}` : ''"                                                  
              item-value="id"
              :error-messages="supplier_id.errorMessage.value"
              clearable                        
            
                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
              <template #label>
                Supplier <span class="text-red-accent-4">*</span>
              </template>
            </v-autocomplete>  

            <v-autocomplete
              label="Branch"
              variant="outlined"
              density="compact"
              bg-color="grey-lighten-4"
              v-model="branch_id.value.value"
              :items="getBranchList"
              :item-title="item => item && item.name && item.code ? `${item.name} - ${item.code}` : ''"                                                  
              item-value="id"
              :error-messages="branch_id.errorMessage.value"
              clearable                        
            
                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
              <template #label>
                Branch <span class="text-red-accent-4">*</span>
              </template>
            </v-autocomplete> 
          </v-col>
          <v-checkbox                            
            label="Active"
            v-model="status.value.value"
            :error-messages="status.errorMessage.value"
            density="compact"
            variant="outlined"
            hide-details
            single-line
            color="primary"
            value="1"
          ></v-checkbox>
          <input v-model="supplier_map_id.value.value" type="hidden">
        </v-row>

        <v-divider></v-divider>
        <v-card-actions>
          <v-layout class="justify-end">
            <v-btn class="bg-red" variant="flat" type="reset"@click="closeDialog">Close</v-btn>
            <v-btn 
              class="bg-brand w-15 ms-2"  
              variant="flat" 
              type="submit"
            >
              {{ isEntryMode ? 'Save' : 'Update' }}
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-form>
    </base-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { toast } from 'vue3-toastify'
import baseCard from "@/components/utils/baseCard.vue";

export default {
  name: 'SupplierMapSetup',
  components: {
    baseCard
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({
        supplier_id: '',
        branch_id: '',
        status: 1,
        supplier_map_id: null,
      })
    }
  },
  data() {
    return {
      localDialog: this.dialog,
      errorMessages: '',
      loading: false,
      isEntryMode: true,
      tempId: '',
    }
  },
  computed: {
    getSupplierList() {
      return this.$store.getters.getSupplierList;
    },
    getBranchList() {
        return this.$store.getters.getBranchList;
    },
    
  },
  watch: {
    dialog(val) {
      this.localDialog = val
    },
    localDialog(val) {
      this.$emit('update:dialog', val)
    },
    data: {
      handler(newData) {
        this.isEntryMode = !newData.id;
        this.resetForm({ errors: {}, touched: {} });
        this.supplier_id.setValue(newData.supplier_id || '', false)
        this.branch_id.setValue(newData.branch_id || '', false);
        this.status.setValue(String(newData.status) || '1', false);
        this.supplier_map_id.setValue(newData.id || '', false);
      },
    }
    
  },
  created() {
      // if(this.$store.getters.getSupplierList.length == 0){
            this.loading = true;
                this.$store.dispatch('getSupplierList').then((response) => {
                this.loading = false;
            })
        // };
        // if(this.$store.getters.getBranchList.length == 0){
            this.loading = true;
                this.$store.dispatch('getBranchList').then((response) => {
                this.loading = false;
            })
        // };
        // if(this.$store.getters.getSupplierMapList.length == 0){
           this.loading = true;
          this.$store.dispatch('getSupplierMapList').then((response) => {
            this.loading = false;
          })
        // };
        
    },
  methods: {
    updateDialog(val) {
      this.$emit('update:dialog', val)
    },
    closeDialog() {
        this.$emit('update:dialog', false);
    },

  },
  setup(props, { emit }){
    const { handleSubmit, resetForm} = useForm({
      validationSchema: yup.object({
          branch_id: yup.number().positive().integer().required().label('Branch'),
          supplier_id: yup.number().positive().integer().required().label('Company'),
      }),

    });

    const supplier_id = useField('supplier_id');
    const branch_id = useField('branch_id');
    const supplier_map_id = useField('supplier_map_id');
    const status = useField('status');
    const errorMessages  = ref('');
    const loading  = ref('');
    const buttonText  = ref('');
    buttonText.value = 'Save';
    const store = useStore();

    const submit = handleSubmit((values) => {
        store.dispatch("saveUpdateSupplierMap", values)
            .then((response) => {
                resetForm();
                emit('update:dialog', false);
                toast.success(response.data.message);
                loading.value = true;
                store.dispatch('getSupplierMapList')
                    .then(data => {
                        loading.value = false;
                    })
                    .catch(error => {
                        loading.value = false;
                        toast.error(error.response.data.message);   
                    })
            })
            .catch((error) => {            
                toast.error(error.response.data.message);          
            })
    });
    return {
      submit,
      supplier_id,
      branch_id,
      supplier_map_id,
      status,
      errorMessages,
      buttonText,
      resetForm,
      loading
    }
  },
  mounted() {
  }
}
</script>

